import { Validators, ValidatorFn } from '@angular/forms';
export class FormValidators {
	static subjectNameValidators: ValidatorFn[] = [
		Validators.required,
		Validators.maxLength(50),
		Validators.pattern(/^(?!.*\s{2,})(?! )[A-Za-z !@#$%^&*(),.?":{}|<>_\-]+(?<! )$/)
	];

	static gradeLevelValidators: ValidatorFn[] = [
		Validators.required,
		Validators.maxLength(20),
		Validators.pattern(/^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/)
	];

	static classroomNameValidators: ValidatorFn[] = [
		Validators.required,
		Validators.maxLength(50),
		Validators.pattern(/^(?=.*[A-Za-z0-9])[A-Za-z0-9!@#$%^&*(),.?":{}|<>_\- ]+$/)
	];
}